import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_SURVEY_SERVICE)

export default {
    async getSurveyList() {
        let headers = {};
        if (store.state.variables.cashSurveyList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashSurveyList', true)
        const res = await apiClient.get('surveyslist', { headers })
        return res.data
    },
    async getSurveyById(id) {
        const res = await apiClient.get(`surveys/${id}`)
        return res.data
    },
    async createSurvey(surveyData) {
        const res = await apiClient.post('surveys', surveyData)
        return res.data
    },
    async updateSurvey(surveyData) {
        const res = await apiClient.put('surveys', surveyData)
        return res.data
    },
    async deleteSurvey(id) {
        const res = await apiClient.delete(`surveys/${id}`)
        return res.data
    },
    async submitSurveyResult(data) {
        const res = await apiClient.post(`surveyresponse`, data)
        return res.data
    },
    async getSurveyResult(params) {
        const { userid, surveyid } = params
        const res = await apiClient.get(`surveyresponse/${userid}&${surveyid}`)
        return res.data
    },
    async getResponseBySurveyId(surveyid) {
        const res = await apiClient.get(`surveyresponse/${surveyid}`)
        return res.data
    },
    async getSilentResponseBySurveyId(surveyid) {
        const headers = { "isSilentAPI": true };
        const res = await apiClient.get(`surveyresponse/${surveyid}`, { headers })
        return res.data
    },
    async getLoggedUserSurveyResult(surveyid) {
        const res = await apiClient.get(`usersurveyresponse/${surveyid}`)
        return res.data
    },

    async getSurveyTargetUsersList() {
        const res = await apiClient.get('surveytargetuserslist')
        return res.data
    },

    async getSurveyRespondersDetails(surveyid) {
        const res = await apiClient.get(`survey-responders-details/${surveyid}`)
        return res.data
    },
}